import { Link, useNavigate } from 'react-router-dom';
import PricingSection from '@/components/PricingSection';
import BrandLogo from '@/components/BrandLogo';
import PublicHeader from '@/components/PublicHeader';
import { getStoredUser } from '@/lib/auth';

export default function Pricing() {
  const navigate = useNavigate();
  // A logged-in employer selecting a plan here must NOT be sent down the
  // visitor path (register/login) — they are already authenticated. Forward
  // them to the employer billing page, which wraps the same PricingSection
  // with the real checkout flow. The chosen plan/cycle ride along as
  // ?plan=&cycle=, exactly the params BillingPlans already reads.
  const storedUser = getStoredUser();
  const isAuthenticated = storedUser?.role === 'employer';

  const handleSelectPlan = (planId, _plan, billingCycle) => {
    if (!isAuthenticated) return; // visitor flow handled inside PricingSection
    navigate(
      `/employer/billing?plan=${planId}` +
        (billingCycle === 'annual' ? '&cycle=annual' : '')
    );
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header — shared with LandingPage (Pricing link auto-hidden on /pricing) */}
      <PublicHeader
        sticky
        isAuthenticated={isAuthenticated}
        dashboardPath="/employer"
        testIdPrefix="pricing-header"
        logoTestId="pricing-home-link"
      />

      <main className="max-w-6xl mx-auto px-6 py-12">
        <PricingSection
          isAuthenticated={isAuthenticated}
          onSelectPlan={isAuthenticated ? handleSelectPlan : null}
        />
      </main>

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-400 py-12 mt-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <BrandLogo variant="white" size="md" />
            </div>
            <div className="flex items-center gap-4 text-sm">
              <Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link>
              <span className="text-slate-600">|</span>
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
              <span className="text-slate-600">|</span>
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <span className="text-slate-600">|</span>
              <Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link>
            </div>
            <p className="text-sm">© 2026 ExpressSub. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
